import React, { useEffect, useRef } from 'react';

const COLORS = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#3b82f6', '#ef4444', '#f97316'];

const ConfettiAnimation = ({ intensity = 'normal' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    const count = intensity === 'high' ? 120 : 70;
    const pieces = [];

    for (let i = 0; i < count; i++) {
      const piece = document.createElement('div');
      const color = COLORS?.[Math.floor(Math.random() * COLORS?.length)];
      const size = Math.random() * 10 + 6;
      const left = Math.random() * 100;
      const delay = Math.random() * 3;
      const duration = Math.random() * 3 + 3;
      const rotation = Math.random() * 360;
      const shape = Math.random() > 0.5 ? '50%' : '0%';

      piece.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        background-color: ${color};
        border-radius: ${shape};
        left: ${left}%;
        top: -20px;
        opacity: 0;
        transform: rotate(${rotation}deg);
        animation: confettiFall ${duration}s ${delay}s ease-in infinite;
      `;
      container?.appendChild(piece);
      pieces?.push(piece);
    }

    return () => {
      pieces?.forEach(p => p?.remove());
    };
  }, [intensity]);

  return (
    <>
      <style>{`
        @keyframes confettiFall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
      `}</style>
      <div
        ref={containerRef}
        className="fixed inset-0 pointer-events-none overflow-hidden"
        style={{ zIndex: 0 }}
        aria-hidden="true"
      />
    </>
  );
};

export default ConfettiAnimation;
